<template>
  <div class="max-w-2xl mx-auto">
    <h2 class="text-lg mb-4 font-bold">{{ __("Storage") }}</h2>

    <div class="mt-4">
      <div class="bg-gray-300 h-6 rounded-xl relative overflow-hidden">
        <div :class="['absolute inset-0 flex items-center justify-end', statusCssClass]" :style="`width: ${storagePercentage}%`">
          <span class="px-4 font-bold text-white text-sm">{{ storagePercentage }}%</span>
        </div>
      </div>
    </div>

    <form class="mx-auto mt-12" @submit.prevent="submit()">
      <h2 class="text-lg mb-6 font-bold">{{ __("Storage cleanup") }}</h2>

      <div class="mb-6 md:flex md:space-x-4">
        <div class="flex-1 w-full mb-4">
          <label class="block text-gray-400 mb-2">{{ __('Start date') }}</label>
          <VueDatePicker v-model="form.startDate" color="#253746" :visible-years-number="100" :no-input="true" :locale="datePickerLocale"/>
          <div v-if="error('startDate')" class="text-red-500 text-sm mt-1">
            {{ error('startDate') }}
          </div>
        </div>
        <div class="flex-1 w-full mb-4">
          <label class="block text-gray-400 mb-2">{{ __('End date') }}</label>
          <VueDatePicker v-model="form.endDate" color="#253746" :visible-years-number="100" :no-input="true" :locale="datePickerLocale"/>
          <div v-if="error('endDate')" class="text-red-500 text-sm mt-1">
            {{ error('endDate') }}
          </div>
        </div>
      </div>

      <div>
        <label class="block text-gray-600 mb-4 font-semibold">{{ __('File type') }}</label>

        <div v-if="error('fileType')" class="text-red-500 text-sm mt-2 mb-4">
          {{ error('fileType') }}
        </div>

        <div class="flex items-center mb-4">
          <input v-model="form.deleteVideos" id="deleteVideos" ref="checkbox" class="border focus:ring focus:border-coral-400" type="checkbox">
          <label class="inline-block text-gray-400 ml-3 text-lg" for="deleteVideos">
            {{ __('Video') }}
          </label>
        </div>
        <div class="flex items-center mb-4">
          <input v-model="form.deleteImages" id="deleteImages" ref="checkbox" class="border focus:ring focus:border-coral-400" type="checkbox">
          <label class="inline-block text-gray-400 ml-3 text-lg" for="deleteImages">
            {{ __('Image') }}
          </label>
        </div>
      </div>

      <div class="mt-6 flex justify-center">
        <loading-button type="submit" :loading="submitting" class="justify-center text-xl px-4 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
          {{ __("Save") }}
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import SettingsLayout from '@/Shared/SettingsLayout';
import TextInput from '@/Shared/TextInput';
import TextareaInput from '@/Shared/TextareaInput';
import LoadingButton from '@/Shared/LoadingButton';
import Icon from '@/Shared/Icon';
import {format} from "date-fns";

export default {
  layout: (h, page) => {
    return h(Layout, [
      h(SettingsLayout, [page]),
    ])
  },
  metaInfo() {
    return {
      title: this.__("Storage"),
    }
  },
  props: {
    storagePercentage: Number
  },
  data() {
    return {
      submitting: false,
      datePickerLocale: window.datePickerLocale,
      form: {
        deleteVideos: false,
        deleteImages: false,
        startDate: format(new Date(), 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd'),
      },
    }
  },
  components: {
    Layout,
    TextInput,
    LoadingButton,
    TextareaInput,
    Icon
  },
  mounted() {
  },
  methods: {
    submit() {
      this.submitting = true;
      this.$inertia.put(this.route('settings.storageCleanup'), this.form, {onFinish: () => this.submitting = false});
    }
  },
  computed: {
    statusCssClass() {
      if (this.storagePercentage >= 75 && this.storagePercentage < 90) {
        return 'bg-yellow-600';
      } else if (this.storagePercentage >= 90) {
        return 'bg-red-600';
      }

      return 'bg-green-600';
    },
  }
}
</script>
